const handlePlayerError = (e) => {
  const metadata = gon.metadata || {};

  NexproErrorHandling(e, metadata);
};

function startLive(data) {
  if (player != null) return player;

  // --- 視聴ログ関連 ---
  if (!viewLog.seminarStartTime) viewLog.startTimer()
  // ------------------

  handleDivBeforePlay();
  var videotag = $('<video>').attr({
    id: "my-player"
    , class: "video-js vjs-default-skin vjs-big-play-centered"
    , controls: ""
    , allowfullscreen: ""
    , mozallowfullscreen: ""
    , preload: "auto"
    , poster: before_poster_url
    , playsinline: ""
  });
  $('#poster_image').after(videotag);

  // while IVS is ON
  if (typeof ivs_live_flag !== 'undefined' && ivs_live_flag) {
    video_settings['techOrder'] = ["AmazonIVS"];
    // Set up IVS playback tech and quality plugin
    registerIVSTech(videojs);
    registerIVSQualityPlugin(videojs);
  } else {
    let set_src = [{
      src: data.src,
      type: "application/x-mpegurl",
      withCredentials: data.with_credentials || false,
    }];
    video_settings.sources = set_src;
  }

  video_settings.controlBar.children = ["qualitySelector"]

  player = videojs('my-player', video_settings, () => {
    console.log('Player is ready to use!');
    // ivsだけ　 Play streamを設定必要です。
    if (typeof ivs_live_flag !== 'undefined' && ivs_live_flag) {
      player.src(data.src);
      player.enableIVSQualityPlugin();
      let playerEvent = player.getIVSEvents().PlayerEventType;
      player.getIVSPlayer().addEventListener(playerEvent.ERROR, (e) => handlePlayerError(e));
    }
  });

  player.on('error', (e) => handlePlayerError(e));
  setListenerOnVideo(player, false);
  return player;
}

function startLiveForVideoCloud(data) {
  if (player != null) return player;

  $('.video-cloud-wrapper').show();
  handleDivBeforePlay();
  player = videojs.getPlayer('vjs_video_3');

  if (typeof (player) == 'undefined') return;
  setListenerOnVideo(player, true);
  return player;
}

function setListenerOnVideo(video, videoCloudFlag) {
  var target_num = 1;
  let qualityLevels = null;
  video.ready(function (e) {
    var player_object = this;
    console.log("ready");

    player_object.on('play', function (e) {
      console.log("play");
      $('#start_message').hide();
      $('#non_start_message').hide();
      $('.my-player-dimensions').addClass("vjs-has-started");

      // --- 視聴ログ関連 ---
      if (viewLog.viewLogIntervalIdList.length >= 1) viewLog.stopAllSetInterval();
      if (!viewLog.startSeconds) viewLog.calculateStartSeconds()
      const videoEl = $("#my-player").children('video')[0];
      const currentTime = player_object.currentTime() + viewLog.startSeconds
      if (!viewLog.isAfterResetSrc && !viewLog.isAfterPaused) viewLog.sendLogToServer(currentTime);
      viewLog.sendViewLogEveryTenSecond('live', {videoEl});

      viewLog.isAfterPaused = false
      // ------------------
    });
    // Can't be run this way when using DVR
    // Will cause the poster image to show when you try to seek
    if (gon.dvr) {
      player_object.dvr();
    } else {
      player_object.on('pause', function (e) {          // --- 視聴ログ関連 ---
        if (!viewLog.isAfterLoadedmetadata) viewLog.isAfterPaused = true
        viewLog.stopAllSetInterval();
        // ------------------

        $('#start_message').show();
        $('.my-player-dimensions').removeClass("vjs-has-started");
      });
    }
    player_object.on('error', function (e) {
      console.log("error");
      var error = player_object.error();
      console.log(error);
      if (live_view.live_status == "end") {
        endLive();
      } else {
        if (gon.schedule_id === undefined || gon.schedule_id === null) {
          return
        }

        window.setTimeout(function () {
          var url = '/api/schedule_status/' + gon.schedule_id + '/' + target_num % 2

          $.get(url).done(function (schedule_status) {
            player.src({
              "type": player.currentType(),
              "src": schedule_status.receive_data.src,
              "withCredentials": schedule_status.receive_data.with_credentials || false
            });
            // player.play();
            target_num++;
          });
        }, 5000);
      }
    });
    player_object.on('fullscreenchange', function () {
      if (this.isFullscreen()) {
        $(this.el_).hide();
        setTimeout(function () {
          $(player_object.el_).show();
        }, 1000);
      }
    });
    player_object.on('loadedmetadata', function (e) {
      // --- 視聴ログ関連 ---
      viewLog.isAfterLoadedmetadata = true
      // ------------------
      // player.pause();
      // window.setTimeout(function () {
      //   player.play();
      // }, 0);
    });

    player_object.tech_.on('retryplaylist', function (e) {
      console.log("retryplaylist");
    });

    if (!videoCloudFlag) {
      // 画質選択ボタン追加
      player.hlsQualitySelector();
    }

    // 電子透かし初期化
    // video_settings変数はlive_view.jsとlibrary_view.jsの両方で設定されているため、
    // 両ファイルが同じページで同時に読み込まれると競合が発生します。
    // そのため、カスタムイベントを呼び出すことで、電子透かし初期化する。
    document.dispatchEvent(
      new CustomEvent('videojs_ready_for_watermark', {detail: video_settings})
    );
  });
}

function handleDivBeforePlay() {
  $('#start_message').show();
  $('#non_start_message').hide();
  $('#chat-post-body').prop("disabled", false);
  $('#chat_pre_message').remove();
  $('#private_chat_btn:not(.hide)').show();
  $('.my-player-dimensions').removeClass("non_button");

  $('#poster_image').hide();
  $('#live_reload').show();
}

function endLive() {
  console.log('=========== endLive ============');

  // --- 視聴ログ関連 ---
  viewLog.stopAllSetInterval();
  // ------------------

  if (show_enquete == false) {
    if (show_end_live_message) return;
    show_end_live_message = true;
    if (!gon.dvr) {
      $('#chat-post-body').val("");
      $('#chat-post-body').prop("disabled", true);
      player.pause();
      player.dispose();
      $('.video-cloud-wrapper').hide();
      $('#poster_image>.vjs-fluid >.vjs-poster').css({backgroundImage: 'url("' + after_poster_url + '")'});
      $('#poster_image').show();
    }
    showEnquete(true);
    showSeminarEndedMessage();
    if (show_end_live_message) return;
    show_end_live_message = true;
  } else {
    setTimeout(endLive, 3000);
  }
}

function rejectedLive() {
  alertMessage(page_message.campaign_capacity_over_note);
  $('#start_message').hide();
  $('#non_start_message').hide();
  $('#full_seminar_message').show();
}

function resetSrc() {
  // $('#stop_delivery_message').hide();

  // --- 視聴ログ関連 ---
  if (viewLog.viewLogIntervalIdList.length >= 1) viewLog.stopAllSetInterval();
  viewLog.isAfterResetSrc = true
  viewLog.startSeconds = 0
  // ------------------

  player.src({
    "src": player.currentSrc(),
    "type": player.currentType(),
    "withCredentials": player.currentSource().withCredentials || false
  });
  // player.play();
}

function showSeminarEndedMessage() {
  var scheduleTab = $("#schedule_tab");
  if (scheduleTab.length) {
    $('.centered').parent().hide();
    jump2nextSchedule();

    scheduleTab.animate({
      backgroundColor: "rgba(100,200,255,0.5)"
    }, 'slow');
    document.getElementById("schedule_tab").addEventListener('click', function () {
        scheduleTab.animate({
          backgroundColor: "transparent"
        }, 'slow');
      }
    )
  }
}

function deliveryStopFunc() {
  // $('#stop_delivery_message').show();
}

function deliveryRestartFunc() {
  // $('#stop_delivery_message').hide();
}

function showEnqueteFunc(show_after_enquete_flag) {
  var check = false;
  if (typeof show_after_enquete_flag === "boolean") {
    check = show_after_enquete_flag;
  } else {
    check = show_after_enquete_flag == "true";
  }
  if (check) {
    $('#enquete_button').show();
  } else {
    $('#enquete_button').hide();
  }
}

/**
 * show/hide private chat button
 * @param isShow it's should show private chat button
 */
function showPrivateChatBtnFunc(isShow) {
  var check = false;
  if (typeof isShow === "boolean") {
    check = isShow;
  } else {
    check = isShow == "true";
  }
  if (check) {
    $('#private_chat_btn').show();
  } else {
    $('#private_chat_btn').hide();
  }
}

function showPrivateChat() {
  if ($('.fix-chat').length == 0) {
    $(".preloader").fadeIn();
    $.post(private_chat_url)
      .always(function () {
        $(".preloader").fadeOut();
      });
  } else {
    var maxWidth = document.body.clientWidth;
    if (maxWidth < $('.fix-chat').width()) {
      $('.fix-chat').width(maxWidth);
    }
    if (maxWidth < $('.fix-chat').offset().left) {
      $('.fix-chat').css('left', 0);
    }
    $('.fix-chat').show();
  }

  return false;
}

$(window).on("focus", function () {
  if (typeof live_view === 'undefined' || false == live_view.is_connect) return;
  $.get(status_check_url).done(function (data) {
    if (live_view.live_status != data.live_status) {
      live_view.view_channel.received(data.receive_data);
    }
  });
});


window.startLive = startLive
window.startLiveForVideoCloud = startLiveForVideoCloud
window.setListenerOnVideo = setListenerOnVideo
window.handleDivBeforePlay = handleDivBeforePlay
window.endLive = endLive
window.rejectedLive = rejectedLive
window.resetSrc = resetSrc
window.showSeminarEndedMessage = showSeminarEndedMessage
window.deliveryStopFunc = deliveryStopFunc
window.deliveryRestartFunc = deliveryRestartFunc
window.showEnqueteFunc = showEnqueteFunc
window.showPrivateChatBtnFunc = showPrivateChatBtnFunc
window.showPrivateChat = showPrivateChat
